const common = [
  {
    property: "twitter:card",
    content: "summary",
  },
  {
    property: "twitter:site",
    content: "@absimoes",
  },
  {
    property: "twitter:title",
    content: "Abner Simões - Front-end & UX Developer",
  },
  {
    property: "twitter:description",
    content:
      "Me chamo Abner Simões, sou desenvolvedor front-end há dez anos, graduado em design digital e entusiasta em UX.",
  },
  {
    property: "twitter:image",
    content: "/img/image.jpg",
  },
  {
    property: "author",
    content: "Abner Simões",
  },
  {
    property: "og:image",
    content: "/img/image.jpg",
  },
];

export const mergeTags = (tags) => {
  return common.concat(tags);
};
